import { For, Show } from "solid-js";
import { OfferConstruct } from "~/server/types/brand";
import { useModal } from "../modal";
import {
  ButtonDarkV2,
  CloseModalButton,
} from "../login-rnr/login_rnr_code_component";
import useScript from "~/utils/hooks/use_script";
import { ribbonConfetti } from "~/assets/assets";

export function ViewOfferDetails(props: {
  offerConstruct: OfferConstruct | undefined;
  playLottie?: boolean;
}) {
  const { closeModal } = useModal()!;

  let ribbonConfettiElement: HTMLInputElement | undefined;

  const lottiePlayerExists =
    typeof window !== "undefined" &&
    window.customElements &&
    window.customElements.get("lottie-player");

  if (props.playLottie && !lottiePlayerExists) {
    useScript(
      "https://unpkg.com/@lottiefiles/lottie-player@0.3.0/dist/lottie-player.js",
      async () => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        try {
          // @ts-ignore
          ribbonConfettiElement?.play();
        } catch (e) {
          console.error(e);
        }
      }
    );
  } else if (props.playLottie) {
    setTimeout(() => {
      try {
        // @ts-ignore
        ribbonConfettiElement?.play();
      } catch (e) {
        console.error(e);
      }
    }, 1000);
  }

  function RibbonConfettiLottie() {
    return (
      <lottie-player
        ref={ribbonConfettiElement}
        src={ribbonConfetti}
        autoplay={false}
        loop={false}
      ></lottie-player>
    );
  }

  return (
    <div class="relative flex w-full flex-col rounded-2xl bg-black darkTheme:border darkTheme:border-[#212427] md:w-[548px]">
      <div class="flex w-full flex-row items-start justify-between p-6">
        <span class="text-nowrap text-h4 text-basePrimaryDark">
          Offer details
        </span>
        <CloseModalButton />
      </div>
      <OfferComponentv2 />

      <div class="p-6 darkTheme:border-t darkTheme:border-[#212427]">
        <ButtonDarkV2 isLoading={false} onClick={() => closeModal()}>
          <p>Got it</p>
        </ButtonDarkV2>
      </div>
      <div class="pointer-events-none absolute left-0 right-0 top-0 flex scale-150">
        <RibbonConfettiLottie />
      </div>
    </div>
  );

  function OfferComponentv2() {
    const list = [
      "Offer details copy comes here",
      "Offer details copy comes here",
      "Offer details copy comes here",
      "Offer details copy comes here",
    ];

    return (
      <div class="px-6 pb-6">
        <For each={list}>{(item) => <div>{item}</div>}</For>
      </div>
    );
  }

  function OfferComponentv1() {
    return (
      <div class="mx-6 mb-5 rounded-2xl border border-[#333232] p-2">
        <div
          classList={{
            "grid w-full grid-cols-3 pr-2 md:px-2":
              props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                .amountUnit === "PERC",
            "grid w-full grid-cols-2 pr-2 md:px-2":
              props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                .amountUnit === "ABS",
          }}
        >
          <p
            class="text-nowrap text-center text-f12Bold text-textNormal md:text-mediumSemiBold"
            classList={{
              "col-span-1": true,
            }}
          >
            Duration
          </p>
          <p
            class="text-nowrap text-center text-f12Bold text-textNormal md:text-mediumSemiBold"
            classList={{
              "col-span-1": true,
            }}
          >
            Discount{" "}
            <Show
              when={
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC"
              }
            >
              %
            </Show>
          </p>
          <Show
            when={
              props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                .amountUnit === "PERC"
            }
          >
            <p class="col-span-1 text-nowrap text-center text-f12Bold text-textNormal md:text-mediumSemiBold">
              Max discount
            </p>
          </Show>
        </div>
        <Show
          when={props.offerConstruct?.subscriptionRewardDetails.length === 2}
        >
          <div
            classList={{
              "mt-2 grid h-[87px] w-full grid-cols-3 items-center rounded-xl bg-[#052514] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC",
              "mt-2 grid h-[87px] w-full grid-cols-2 items-center rounded-xl bg-[#052514] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "ABS",
            }}
          >
            <div class="col-span-1 flex items-center justify-center text-nowrap text-bold text-[#24DD7D]">
              {props.offerConstruct?.subscriptionRewardDetails[1].tenure} months
            </div>
            <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
              <p class="text-bold text-white">
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "ABS"
                  }
                >
                  ₹
                </Show>
                {
                  props.offerConstruct?.subscriptionRewardDetails[1]
                    .rewardDetails.value
                }
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "PERC"
                  }
                >
                  %
                </Show>{" "}
                off
              </p>
              <p class="text-medium text-white opacity-[0.6]">every month</p>
            </div>
            <Show
              when={
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC"
              }
            >
              <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
                <p class="text-bold text-white">
                  ₹
                  {
                    props.offerConstruct?.subscriptionRewardDetails[1]
                      .rewardDetails.maxAmount
                  }
                </p>
                <p class="text-medium text-white opacity-[0.6]">every month</p>
              </div>
            </Show>
          </div>
          <div
            classList={{
              "mt-2 grid h-[87px] w-full grid-cols-3 items-center rounded-xl bg-[#07262F] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC",
              "mt-2 grid h-[87px] w-full grid-cols-2 items-center rounded-xl bg-[#07262F] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "ABS",
            }}
          >
            <div class="col-span-1 flex items-center justify-center text-nowrap text-bold text-[#4AC4E5]">
              {props.offerConstruct?.subscriptionRewardDetails[0].tenure} months
            </div>
            <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
              <p class="text-bold text-white">
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "ABS"
                  }
                >
                  ₹
                </Show>
                {
                  props.offerConstruct?.subscriptionRewardDetails[0]
                    .rewardDetails.value
                }
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "PERC"
                  }
                >
                  %
                </Show>{" "}
                off
              </p>
              <p class="text-medium text-white opacity-[0.6]">every month</p>
            </div>
            <Show
              when={
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC"
              }
            >
              <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
                <p class="text-bold text-white">
                  ₹
                  {
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.maxAmount
                  }
                </p>
                <p class="text-medium text-white opacity-[0.6]">every month</p>
              </div>
            </Show>
          </div>
        </Show>
        <Show
          when={props.offerConstruct?.subscriptionRewardDetails.length === 1}
        >
          <div
            classList={{
              "mt-2 grid h-[87px] w-full grid-cols-3 items-center rounded-xl bg-[#07262F] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC",
              "mt-2 grid h-[87px] w-full grid-cols-2 items-center rounded-xl bg-[#07262F] p-2 md:w-[479px]":
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "ABS",
            }}
          >
            <div class="col-span-1 flex items-center justify-center text-nowrap text-bold text-[#4AC4E5]">
              {props.offerConstruct?.subscriptionRewardDetails[0].tenure} months
            </div>
            <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
              <p class="text-bold text-white">
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "ABS"
                  }
                >
                  ₹
                </Show>
                {
                  props.offerConstruct?.subscriptionRewardDetails[0]
                    .rewardDetails.value
                }
                <Show
                  when={
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.amountUnit === "PERC"
                  }
                >
                  %
                </Show>{" "}
                off
              </p>
              <p class="text-medium text-white opacity-[0.6]">every month</p>
            </div>
            <Show
              when={
                props.offerConstruct?.subscriptionRewardDetails[0].rewardDetails
                  .amountUnit === "PERC"
              }
            >
              <div class="col-span-1 flex flex-col items-center justify-center text-nowrap">
                <p class="text-bold text-white">
                  ₹
                  {
                    props.offerConstruct?.subscriptionRewardDetails[0]
                      .rewardDetails.maxAmount
                  }
                </p>
                <p class="text-medium text-white opacity-[0.6]">every month</p>
              </div>
            </Show>
          </div>
        </Show>
      </div>
    );
  }
}
